import * as THREE from 'three'
import { Renderer } from '@components/Graphics/Renderer'
import { OBJLoader } from 'three/addons/loaders/OBJLoader.js';
export class MeshRenderer extends Renderer {
  mesh!: THREE.Mesh[]
  onLoadPromise!: Promise<void>

  setup(data: any) {
    super.setup(data)
    this.onLoadPromise = new Promise<void>((resolve, _reject) => {
      this.mesh = [new THREE.Mesh(data.geometry, data.material)]
      if (data.geometryPath) {
        const loader = new OBJLoader();
        loader.loadAsync(data.geometryPath).then((obj) => {
          this.mesh = []
          for (let i = 0; i < obj.children.length; i++) {
            const meshObject = obj.children[i]
            //cast to THREE.Mesh
            const mesh = meshObject as THREE.Mesh

            this.mesh.push(mesh)
          }
          console.log(this.mesh)
          this.reloadDisplayedMeshs()
          resolve()
        })
      } else {
        this.reloadDisplayedMeshs()
        resolve()
      }
    })

  }
  reloadDisplayedMeshs() {
    this.object3D.clear()
    for (let i = 0; i < this.mesh.length; i++) {
      this.object3D.add(this.mesh[i])
      this.mesh[i].castShadow = true
      this.mesh[i].receiveShadow = true
    }
  }
  start() {
    super.start()
  }
  onMove(): void {
    super.onMove()
  }
  render(_dt: number) {
  }
  onActiveStateChanged(): void {
    for (let i = 0; i < this.mesh.length; i++) {
      this.mesh[i].visible = this.enabled
    }
  }
  onDestroy() {
    super.onDestroy()
    for (let i = 0; i < this.mesh.length; i++) {
      this.object3D.remove(this.mesh[i])
      this.mesh[i].geometry.dispose()
      const material = this.mesh[i].material
      if (material instanceof THREE.Material) {
        material.dispose()
      } else if (Array.isArray(material)) {
        material.forEach((m) => m.dispose())
      }
    }
  }
}
